export default __webpack_public_path__ + "static/media/parnter-three.b62ca43c.png";